import { createFileRoute } from "@tanstack/react-router";
import CpaVsTaxAttorney from "@/pages/site/CpaVsTaxAttorney";

export const Route = createFileRoute("/resources/cpa-vs-tax-attorney-for-irs-help")({
  component: () => <CpaVsTaxAttorney />,
});
